/* ELORE — lightweight motion + UI, replacing Framer Motion / React.
   No dependencies. Progressive enhancement: everything is visible if JS fails. */
(function () {
  document.documentElement.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveals + masked hero lines ---- */
  function initReveals() {
    var items = document.querySelectorAll('.reveal, .mask-line');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.getAttribute('data-delay') || '0');
        setTimeout(function () { el.classList.add('is-visible'); }, delay * 1000);
        io.unobserve(el);
      });
    }, { rootMargin: '-10% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---- Parallax (hero image, video panels) via data-parallax ---- */
  function initParallax() {
    if (reduceMotion) return;
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!nodes.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      nodes.forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.bottom < -vh || rect.top > vh * 2) return;
        var speed = parseFloat(node.getAttribute('data-parallax')) || 0.12;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1..1-ish
        node.style.transform = 'translate3d(0,' + (progress * speed * 100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- Sticky header state ---- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 24); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile drawer ---- */
  function initMobileMenu() {
    var openBtn = document.querySelector('[data-menu-open]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (!openBtn || !drawer) return;
    function set(open) {
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openBtn.addEventListener('click', function () { set(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { set(false); });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { set(false); });
    });
  }

  /* ---- Video sound toggle ---- */
  function initVideoSound() {
    document.querySelectorAll('[data-video-toggle]').forEach(function (btn) {
      var section = btn.closest('[data-video-section]');
      if (!section) return;
      var video = section.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        var next = !(!video.muted); // toggle
        video.muted = !video.muted;
        if (!video.muted) { video.volume = 1; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        btn.classList.toggle('is-on', !video.muted);
        var label = btn.querySelector('[data-video-label]');
        if (label) label.textContent = video.muted ? 'Sound off' : 'Sound on';
      });
    });
  }

  function init() {
    initReveals();
    initParallax();
    initHeader();
    initMobileMenu();
    initVideoSound();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
